import routes from 'constants/route';

export function isPublicUrl(): boolean {
  return window.location.pathname === routes.orderContracts;
}
